import { Component, input, output } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { Tab } from '../../../../core/types/general';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-tabs-list',
  imports: [TranslateModule, NgOptimizedImage],
  templateUrl: './tabs-list.component.html',
  styleUrl: './tabs-list.component.scss',
})
export class TabsListComponent {
  readonly tabs = input.required<Tab[]>();
  readonly selected = input.required<number>();
  tabsChange = output<number>();
}
